import React, { Component } from "react";
import {Control, Form} from "react-redux-form";
import {formatMoney} from "accounting-js";
import { confirmAlert } from 'react-confirm-alert';
import moment from "moment/moment";
import _ from "lodash";
import Loading from "../loading";
import TextEditor from "../forms/wysiwyg_field";

export default class CommissionValidationForm extends Component{
	render(){
		const { resource_concepts, revision } = this.props;
		const { commission } = revision;
		const { project } = commission;
		//console.log('validaciones: ', _.isEmpty(revision.commission));
		let projectRev = commission.revision ? commission.revision.body : undefined;
		return(
			revision.isFetching ? <Loading/>:
				<div className="columns is-centered">
					<div className="column is-10">
						<div style={{display:this.state.formShow===false ? 'block':'none'}}>
							<div className="columns">
								<div className="column is-10">
									<div className="content">
										<p>A continuación se te asignará un proyecto para su revisión y validación, recuerda que al finalizar la revisión tienes que marcar la casilla de verificación, en este paso no hay vuelta atrás y no podrás regresar al proyecto anterior.</p>
									</div>
								</div>
							</div>
							<div className="columns">
								<div className="column">
									<button className="button is-medium is-success" onClick={() => {this._getSurvey()}} disabled={this._permissionAssing()}>
										<span>{_.isEmpty(commission.spvpu) ? '¡ Asígname un proyecto !':'¡ Continuar revisión !'}</span>
										{_.isEmpty(commission.spvpu) ?
											<span className="icon is-medium">
											<i className="fa fa-random"/>
										</span>:
											<span className="icon is-medium">
											<i className="fa fa-play"/>
										</span>}

									</button>
								</div>
							</div>
							{!_.isEmpty(commission.projects) ?
								<div className="columns">
									<div className="column">
										<div className="field is-grouped">
											<div className="control">
												<p style={{marginBottom:'.5em'}}>&nbsp;</p>
												<div className="tags has-addons">
													<span className="tag is-medium is-dark">Proyectos revisados</span>
													<span className="tag is-medium is-inm-purple">{commission.projects.assigned}</span>
												</div>
											</div>

											<div className="control">
												<p style={{marginBottom:'.5em'}}>&nbsp;</p>
												<div className="tags has-addons">
													<span className="tag is-medium is-dark">Total disponibles</span>
													<span className="tag is-medium is-info">{commission.projects.available}</span>
												</div>
											</div>

											<div className="control">
												<p style={{marginBottom:'.5em'}}>&nbsp;</p>
												<div className="tags has-addons">
													<span className="tag is-medium is-dark">Proyectos sin revisar</span>
													<span className="tag is-medium is-warning">{commission.projects.missing >= 0 ? commission.projects.missing:0}</span>
												</div>
											</div>

											<div className="control">
												<p style={{marginBottom:'.5em'}}>&nbsp;</p>
												<div className="tags has-addons">
													<span className="tag is-medium is-dark">Total de proyectos</span>
													<span className="tag is-medium is-success">{commission.projects.total}</span>
												</div>
											</div>
										</div>
									</div>
								</div>
								:''}
						</div>
						{this.state.conagoShow ? <ConagoModal active={this.state.conagoShow} closeModal={() => this._toggleConagoModal()} selectedConago={project.project_goals[this.state.selectedGoal].conago_clauses} selectedGoal={this.state.selectedGoal} conagoClauses={this.props.directories} />:''}
						{this.state.actorsShow ? <ActorsModal active={this.state.actorsShow} closeModal={() => this._toggleActorsModal()} selectedActors={project.project_goals[this.state.selectedGoal].actors} selectedGoal={this.state.selectedGoal} actors={this.props.directories} />:''}
						{!_.isEmpty(revision.commission.project) ?
							<Form model="revision.commission" onSubmit={(values) => this._handleSubmit(values)} style={{display:this.state.formShow ? 'block':'none'}}>
								<table className="table is-fullwidth project-goal-table no-margin">
									<tbody>
									<tr>
										<td colSpan="4" className="goal-cell">
											<span className="help is-white">{project && project.modality.name ? project.modality.name:'---'}</span>
											<strong>DATOS GENERALES</strong>
										</td>
									</tr>
									<tr>
										<td colSpan="2" className="goal-cell" style={{width:'50%'}}>
											<strong>Instrucciones</strong>
										</td>
										<td colSpan="2" className="goal-cell">
											<strong>Datos del proyecto</strong>
										</td>
									</tr>
									<tr>
										<td colSpan="2">
											<p>1. Seleccionar la valoración para cada rubro a calificar del proyecto, de acuerdo con lo establecido en los Criterios de Operación de la CVP.</p>
											<p>2. En su caso, emitir comentarios generales en cada sección.</p>
										</td>
										<td colSpan="2">
											<div className="columns">
												<div className="column">
													<span className="help is-dark">Folio de participación:</span>
													<strong>{project && project.code ? project.code:'---'}</strong>
												</div>
												<div className="column">
													<span className="help is-dark">Modalidad:</span>
													<strong>{project && project.modality.name ? project.modality.name:'---'}</strong>
												</div>
											</div>
											<div className="columns">
												<div className="column is-1">
													<i className="fa fa-usd fa-2x" />
												</div>
												<div className="column">
													<span className="help is-dark">Monto proyecto</span>
													<small><strong> {project && project.amounts ? `${formatMoney(project.amounts.total)}` : '---'}</strong></small>
												</div>
												<div className="column is-1">
													<i className="fa fa-calendar fa-2x" />
												</div>
												<div className="column">
													<span className="help is-dark">Periodo de ejecución</span>
													<small><strong>{_.capitalize(moment(project.execution_start).format('MMMM YYYY'))} a {_.capitalize(moment(project.execution_end).format('MMMM YYYY'))}</strong></small>
												</div>
											</div>
										</td>
									</tr>
									<tr>
										<td colSpan="2" style={{verticalAlign:'top',padding:'0 0'}}>
											<table>
												<tbody>
												<tr>
													<td className="goal-cell">
														<strong>Preguntas</strong>
													</td>
												</tr>
												{!_.isEmpty(revision.commission.spvpu) && !_.isEmpty(revision.commission.spvpu.survey_version_phase) ?
													_.map(revision.commission.spvpu.survey_version_phase.survey.children_questions,(row,key)=>{
														//console.log('row: ',row);
														if(row.type === 'group'){
															return [
																<tr key={`group-${key}`}>
																	<td>
																		<strong>{(key+1)+'. '+row.name}</strong>
																	</td>
																</tr>,
																_.map(row.children_questions,(item,k) => {
																	return <RowQuestion key={k} model={`revision.commission.answers[${key}]`} row={item} {...this.props}/>
																})
															]
														}else {
															return <RowQuestion key={key} number={key+1} model={`revision.commission.answers[${key}]`}  row={row} {...this.props}/>
														}
													}):''}
												<tr>
													<td className="goal-cell">
														<strong>Comentarios generales</strong>
													</td>
												</tr>
												<tr>
													<td style={{verticalAlign:'top',padding:'0 0'}}>
														<div className="field is-grouped">
															<div className="control is-expanded">
																<Control.textarea model=".comments" component={TextEditor} />
															</div>
														</div>
													</td>
												</tr>
												<tr>
													<td className="goal-cell">
														<div className="level">
															<strong className="level-left">Puntuación total:</strong>
															<strong className="level-right">{this._totalScore()}</strong>
														</div>
													</td>
												</tr>
												</tbody>
											</table>
										</td>
										<td colSpan="2" style={{verticalAlign:'top',padding:'0 0'}}>
											<table>
												<tbody>
												<tr>
													<td style={{width:'70%'}}>
														<span className="help is-dark">Instancia</span>
														<small><strong>{project.agency.name ? project.agency.name : '---'}</strong></small>
													</td>
													<td>
														<span className="help is-dark">Localidad</span>
														<small><strong>{project.agency && project.agency.agenciable ? project.agency.agenciable.name : '---'}</strong></small>
													</td>
												</tr>
												<tr>
													<td colSpan="2">
														<span className="help is-dark">Proyecto</span>
														<small><strong>{project.name ? project.name : '---'}</strong></small>
													</td>
												</tr>
												<tr>
													<td colSpan="2">
														<span className="help is-dark">Objetivo</span>
														<small><span dangerouslySetInnerHTML={{__html:project.objective ? project.objective : '---'}}></span></small>
													</td>
												</tr>
												<tr>
													<td colSpan="2">
														<span className="help is-dark">Justificación</span>
														<small><span dangerouslySetInnerHTML={{__html:project.justification ? project.justification : '---'}}></span></small>
													</td>
												</tr>
												</tbody>
												{_.map(project.project_goals, (goal, key) => {
													return (
														<tbody key={key}>
														<tr>
															<td colSpan={2} className="goal-cell">
																<span className="help is-white">Meta</span>
																<small><strong>{goal.name}</strong></small>
															</td>
														</tr>
														<tr>
															<td>
																<span className="help is-inm-purple">Código</span>
																<small><strong className="has-text-inm-purple">{goal.code}</strong></small>
															</td>
															<td>
																<span className="help is-dark">Monto</span>
																<small><strong>{formatMoney(goal.total)}</strong></small>
															</td>
														</tr>
														<tr>
															<td colSpan={2}>
																<div className="columns">
																	{project && project.modality && project.modality.slug === 'modalidad-i' ?
																	<div className="column">
																		<div className="tags has-addons" style={{cursor:'pointer'}}>
																			<span className="tag is-light" onClick={() => this._openConagoModal(goal.proigualdad_goal_id, goal.conagoClauses)}>Metas CONAGO</span>
																			<span className="tag is-white">{_.size(goal.conago_clauses)}</span>
																		</div>
																	</div>:''}

																	<div className="column">
																		<div className="tags has-addons" style={{cursor:'pointer'}}>
																			<span className="tag is-light" onClick={() => this._openActorsModal(goal.proigualdad_goal_id, goal.actors)}>Actores estratégicos</span>
																			<span className="tag is-white">{_.size(goal.actors)}</span>
																		</div>
																	</div>
																</div>
															</td>
														</tr>
														<tr>
															<td colSpan={2}>
																<span className="help is-dark">Eje temático</span>
																<small><strong>{goal.axis ? goal.axis.name:'---'}</strong></small>
															</td>
														</tr>
														<tr>
															<td colSpan={2}>
																<span className="help is-dark">Línea de acción</span>
																<small><strong>{goal.line ? goal.line.name:'---'}</strong></small>
															</td>
														</tr>
														<tr>
															<td colSpan={2}>
																<span className="help is-dark">Concepto de gasto</span>
																{goal.resource_concept_id && resource_concepts && resource_concepts.list ?
																	<small>{_.find(resource_concepts.list, {id: goal.resource_concept_id}).name}</small> : ''}
															</td>
														</tr>
														<tr>
															<td colSpan={2}>
																<span className="help is-dark">Documento meta</span>
																<small><strong>{goal.goal_document}</strong></small>
															</td>
														</tr>
														</tbody>
													)
												})}
												<tbody>
												<tr>
													<td colSpan={2} className="goal-cell">
														<small><strong>RESUMEN DE GASTOS</strong></small>
													</td>
												</tr>
												<tr>
													<td>
														<span className="help is-dark">Concepto</span>
														<small>Gasto total del proyecto</small>
													</td>
													<td className="has-text-right">
														<span className="help is-dark">Total</span>
														<small><strong>{project.amounts && project.amounts.goals ? formatMoney(_.toNumber(project.amounts.goals.total)) : '--'}</strong></small>
													</td>
												</tr>
												<tr>
													<td>
														<span className="help is-dark">Concepto</span>
														<small>Gastos de coordinación</small>
													</td>
													<td className="has-text-right">
														<span className="help is-dark">Total</span>
														<small><strong>{project.amounts && project.amounts.expenses ? formatMoney(_.toNumber(project.amounts.expenses.total)) : '--'}</strong></small>
													</td>
												</tr>
												<tr>
													<td className="goal-cell">
														<span className="help is-white">Concepto</span>
														<small><span className="has-text-white">Monto total del proyecto</span></small>
													</td>
													<td className="goal-cell has-text-right">
														<span className="help is-white">Total</span>
														<small><strong>{project.amounts ? formatMoney(_.toNumber(project.amounts.total)) : '--'}</strong></small>
													</td>
												</tr>
												<tr>
													<td colSpan={2} className="goal-cell">
														<strong>Comentarios de revisión</strong>
													</td>
												</tr>
												<tr>
													<td colSpan={2}>
														<small><span dangerouslySetInnerHTML={{__html:projectRev && projectRev.comments && projectRev.comments !== '<p><br></p>' ? projectRev.comments : 'Ninguno'}}></span></small>
													</td>
												</tr>
												</tbody>
											</table>
										</td>
									</tr>
									</tbody>
								</table>

								<div className="message is-success">
									<div className="message-body">
										<div className="field">
											<div className="control">
												<label htmlFor="finished" className="checkbox" disabled={this._permissionSave()}>
													<Control.checkbox model=".finished" id="finished" className="checkbox" disabled={this._permissionSave()}/>
													<span style={{whiteSpace:'normal'}}>He concluido y certifico que la información proporcionada es correcta y completa; conozco las disposiciones establecidas en las Reglas de Operación del PFTPG 2018.</span>
												</label>
											</div>
										</div>
									</div>
								</div>

								<div className="columns ">
									<div className="column">
										<div className="field is-grouped is-grouped-right">
											<div className="control">
												<button type="button" model="validation" className="button is-danger" onClick={() => this.props.history.push('/inicio')}>Regresar</button>
											</div>

											<div className="control">
												<Control.button model="validation.edit" className="button is-success" disabled={_.size(revision.commission.answers)>0 ? false:true}>Guardar</Control.button>
											</div>
										</div>
									</div>
								</div>
							</Form>
							:''}
					</div>
				</div>
		)
	}

	constructor() {
		super();
		this.state = {
			conagoShow: false,
			actorsShow: false,
			formShow: false,
			goalConago: [],
			goalActors: [],
			selectedGoal: 0
		}
	}

	componentWillReceiveProps(props) {
		if(this.state.formShow && _.isEmpty(props.revision.commission.spvpu)){
			this.setState({
				formShow: false
			})
		}
	}

	_handleSubmit(values){
		this.props.surveysSaveAnswer(values);
		if(values.finished){
			this.setState({
				formShow: !this.state.formShow
			})
		}
		//console.log('values: ', values)
	}

	_permissionAssing() {
		const { commission } = this.props.revision;
		if(!_.isEmpty(commission.spvpu)){
			return false;
		}else if(!_.isEmpty(commission.projects) && _.isEmpty(commission.spvpu) && _.toInteger(commission.projects.assigned) < _.toInteger(commission.projects.available)){
			return false;
		}
		else {
			return true;
		}
	}

	_permissionSave() {
		const { commission } = this.props.revision;
		let total = 0; let answers = 0;

		if(commission.spvpu && commission.spvpu.survey_version_phase && commission.spvpu.survey_version_phase.survey){
			_.map(commission.spvpu.survey_version_phase.survey.children_questions, (item) => {
				if(item.type === 'group'){
					_.map(item.children_questions,() => {
						total = total +1;
					})
				}else {
					total = total +1;
				}
			})
		}

		if(!_.isEmpty(commission.answers)){
			_.map(commission.answers, (item) => {
				if(item.answer_text){
					answers = answers +1;
				}
			})
		}

		if(total>0){
			if(total!== answers){
				return true;
			}else {
				return false;
			}
		}else {
			return true;
		}
	}

	_totalScore(){
		let { commission } = this.props.revision;
		let total_score=commission && commission.answers ? _.sum(_.map(commission.answers,(row)=>{
			if(row){
				return row.answer_number;
			}else {
				return 0;
			}
		})):0;

		return total_score;
	}

	_openConagoModal(goal, selected) {
		let editGoal = _.findKey(this.props.revision.commission.project.project_goals, {proigualdad_goal_id:goal});
		this.setState({
			conagoShow: true,
			goalConago: selected,
			selectedGoal: editGoal
		})
	}

	_openActorsModal(goal, selected) {
		let editGoal = _.findKey(this.props.revision.commission.project.project_goals, {proigualdad_goal_id:goal});
		this.setState({
			actorsShow: true,
			goalActors: selected,
			selectedGoal: editGoal
		})
	}

	_toggleConagoModal() {
		this.setState({conagoShow: !this.state.conagoShow});
	}

	_toggleActorsModal() {
		this.setState({actorsShow: !this.state.actorsShow});
	}

	_getSurvey() {
		const { commission } = this.props.revision;
		if(_.isEmpty(commission.spvpu)){
			if(!_.isEmpty(commission.projects) && _.toInteger(commission.projects.assigned) < _.toInteger(commission.projects.available)){
				confirmAlert({
					title: '¿Está seguro?',
					message: 'Esta acción es irreversible. Una vez que te sea asignado un proyecto, debes revisarlo y marcar la casilla de finalización al terminar.',
					confirmLabel: 'Aceptar',
					cancelLabel: 'Cancelar',
					onConfirm: () => {
						this.props.assignCommission();
						this.setState({
							formShow: true
						})
					}
				})
			}else {
				this.props.setSystemNotification("¡Oh no!","Ya no es posible asignar mas proyectos", "danger");
			}
		}else {
			this.setState({
				formShow: true
			})
		}

	}

	_changeOption(model, valueNumber, valueText, questionId, index) {
		const { commission } = this.props.revision;
		this.props.change(`revision.commission.answers[${index}]`,{spvpu_id: commission.spvpu.id, question_id: questionId,answer_number: _.toInteger(valueNumber), answer_text: valueText});
	}
}

class RowQuestion extends Component {
	render(){
		let { row, revision} = this.props
		let findValue = _.find(revision.commission.answers, {question_id: row.id});
		return(
			<tr>
				<td>
					{this.props.number ?
					<div className="field">
						<strong>{(this.props.number)+'. '+row.name}</strong>
					</div>:<p>{row.name}</p>}
					<div className="field is-grouped is-grouped-multiline">
						{row.type === 'sum' ?
							_.map(row.options,(opc,k) => {
								//console.log('question: ', key, 'opcion: ', opc.option_number);
								let check = findValue && findValue.answer_number === opc.option_number ? true:false;
								return (
									<div className="control" key={k}>
										<label htmlFor={`Q${row.id}-answers-${opc.id}`} className="radio">
											{/*<Control.radio model={`.answer_number`} id={`Q${row.id}-answers-${opc.id}`} value={findValue ? findValue.answer_number:undefined} changeAction={(model, value) => this._changeOption(model, value, opc.option_text, row.id)}/>*/}
											<input type="radio" checked={check} id={`Q${row.id}-answers-${opc.id}`} value={opc.option_number} onChange={(e) => this._changeOption(e.target.value,opc.option_text, row.id)}/>
											{opc.option_text}
										</label>
									</div>
								)
							})
							:<textarea rows={2} className="textarea" id={`question-${row.id}`} ref={`question-${row.id}`} value={findValue ? findValue.answer_text:undefined} onChange={(e) => this._changeText(e.target.value, row.id)} />}
					</div>
					<br/>
				</td>
			</tr>
		)
	}

	_changeOption(valueNumber, valueText, questionId) {
		const { commission } = this.props.revision;
		let findIndex = _.findIndex(commission.answers, {question_id: questionId});

		if(findIndex !== -1){
			this.props.change(`revision.commission.answers[${findIndex}]`,{spvpu_id: commission.spvpu.id, question_id: questionId,answer_number: _.toInteger(valueNumber), answer_text: valueText});
		}else {
			this.props.add('revision.commission.answers', {spvpu_id: commission.spvpu.id, question_id: questionId,answer_number: _.toInteger(valueNumber), answer_text: valueText});
		}
	}

	_changeText(value, questionId){
		const { commission } = this.props.revision;
		let findIndex = _.findIndex(commission.answers, {question_id: questionId});
		if(findIndex !== -1){
			this.props.change(`revision.commission.answers[${findIndex}]`,{spvpu_id: commission.spvpu.id, question_id: questionId,answer_text: value});
		}else {
			this.props.add('revision.commission.answers', {spvpu_id: commission.spvpu.id, question_id: questionId,answer_text: value});
		}
	}
}

class ConagoModal extends Component {
	render() {
		return (
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" onClick={this.props.closeModal}/>
				<div className="modal-content">
					<div className="message">
						<div className="message-header">
							<p>Metas CONAGO seleccionadas</p>
							<button type="button" onClick={this.props.closeModal} className="delete is-medium" aria-label="delete"></button>
						</div>
						<div className="message-body">
							{this.props.conagoClauses.isFetching ? <Loading /> :
								<div className="content">
									<ul>
										{_.map(this.props.selectedConago, (conago, k) => {
											return <li key={k}>{conago.name}</li>
										})}
									</ul>
								</div>
							}

							<br /><br />
							<div className="field is-grouped is-grouped-right">
								<div className="control">
									<button className="button is-info" type="button" onClick={this.props.closeModal}>Cerrar</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

class ActorsModal extends Component {
	render() {
		return (
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" onClick={this.props.closeModal}/>
				<div className="modal-content">
					<div className="message">
						<div className="message-header">
							<p>Actores estratégicos seleccionados</p>
							<button type="button" onClick={this.props.closeModal} className="delete is-medium" aria-label="delete"></button>
						</div>
						<div className="message-body">
							{this.props.actors.isFetching ? <Loading /> :
								<div className="content">
									<ul>
										{_.map(this.props.selectedActors, (actor, k) => {
											return <li key={k}>{actor.name}</li>
										})}
									</ul>
								</div>
							}

							<br /><br />
							<div className="field is-grouped is-grouped-right">
								<div className="control">
									<button className="button is-info" type="button" onClick={this.props.closeModal}>Cerrar</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/elements/revision/commission.jsx